import TextField from '@atlaskit/textfield';
import { ChangeEvent, SyntheticEvent } from 'react';
import styled from 'styled-components';

import { TogglTimeEntry } from '../../../../types/toggl-api';

interface IssueKeyCellProps {
  isDisabled: boolean;
  mappedJiraIssueKey: string | undefined;
  tempJiraIssueKey: string | undefined;
  timeEntry: TogglTimeEntry;
  onChange: (timeEntryId: number, issueKey: string) => void;
}
export function IssueKeyCell({
  isDisabled,
  mappedJiraIssueKey,
  tempJiraIssueKey = '',
  timeEntry,
  onChange,
}: IssueKeyCellProps) {
  const onClick = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  if (mappedJiraIssueKey) {
    return <span>{mappedJiraIssueKey}</span>;
  }

  return (
    <IssueKeyCellWrapper>
      <TextField
        isDisabled={isDisabled}
        style={{ height: 32 }}
        value={tempJiraIssueKey}
        onClick={onClick}
        placeholder="-"
        id={`${timeEntry.id}-text-field`}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(timeEntry.id, e.target.value)
        }
      />
    </IssueKeyCellWrapper>
  );
}

const IssueKeyCellWrapper = styled.div`
  width: 86px;
`;
